<span (click)="workflowSvc.openTask(workflowInstance)" class="cursor button-status">
      <i class="fas fa-square" [style.color]="'#'+workflowInstance?.hexCouleurWorkflowStatut"></i>
     {{prefix}} {{workflowInstance?.libelleWorkflowStatut}}
</span>
